import {
	get,
	post
} from '../utils/request.js'


export default {
	// 获取专利列表 
	getpatentlist(data) {
		return post('/api/patent/patentlist', data)
	},
	//专利排队-预定
	setreserve(data) {
		return post('/api/patent/patentreserve', data)
	},
	//导出数据
	exportexecl(data,options) {
		return post('/api/patent/exportexecl', data,options)
	},
	// 获取我的专利列表
	getmypatentlist(data) {
		return post('/api/patent/mypatentlist', data)
	},
	// 获取我的专利预约列表
	getmypatentyuyuelist(data) {
		return post('/api/patent/mypatentyuyuelist', data)
	},
	// 单条添加专利
	dtaddpatent(data) {
		return post('/api/patent/addpatent', data)
	},
	// 批量添加专利
	dtpladdpatent(data) {
		return post('/api/patent/addplpatent', data)
	},
	// 根据id删除专利
	delpatent(data) {
		return post('/api/patent/delpatent', data)
	},
	// 一键删除代售专利
	yjdelpatent(){
		return post('/api/patent/yjdelpatent')
	},
	// 编辑专利
	editpatent(data){
		return post('/api/patent/editpatent', data)
	},
	// 行内编辑专利
	lineeditpatent(data){
		return post('/api/patent/lineeditpatent', data)
	},
	// 出售专利
	shoppatent(data){
		return post('/api/patent/shoppatent', data)
	},
	// 历史预约
	getqueueList(data){
		return post('/api/patent/myqueueList', data)
	},
	// 上传专利
	uploadexlec(data){
		return post('/api/patent/uploadexlec', data)
	},
	// 上传专利
	plscpatent(data){
		return post('/api/patent/plscpatent', data)
	},
	// 同意预约
	tyyypatent(data){
		return post('/api/patent/tyyypatent', data)
	},
	// 拒绝预约
	jjyypatent(data){
		return post('/api/patent/jjyypatent', data)
	},
	// 延长预约
	ycyypatent(data){
		return post('/api/patent/ycyypatent', data)
	}

}